export const fontStyles = `
  @font-face {
      font-family: "IBM Plex Sans";
      font-weight: 600;
      src: url("https://rocketlane-attachments-public.s3.amazonaws.com/fonts/IBMPlexSans-Bold.ttf") format("truetype");
  }

  @font-face {
      font-family: "IBM Plex Sans";
      font-weight: 300;
      src: url("https://rocketlane-attachments-public.s3.amazonaws.com/fonts/IBMPlexSans-Light.ttf") format("truetype");
  }

  @font-face {
    font-family: "IBM Plex Sans";
    font-weight: 400;
    src: url("https://rocketlane-attachments-public.s3.amazonaws.com/fonts/IBMPlexSans-Regular.ttf") format("truetype");
  }

  @font-face {
    font-family: "IBM Plex Sans";
    src: url("https://rocketlane-attachments-public.s3.amazonaws.com/fonts/IBMPlexSans-Regular.ttf") format("truetype");
  }

  @font-face {
    font-family: "Rockelane Emoji";
    src: url("https://rocketlane-attachments-public.s3.amazonaws.com/fonts/seguiemj.ttf") format("truetype");
  }
`;
